import React, { useState, useEffect } from 'react';
import CommonInput from '../../Common/CommonInput';

const GeneralSettingsForm = ({ initialData, onSave, isLoading, onClose }) => {
    const defaultSidebarColor = '#212333';
    const [formData, setFormData] = useState({
        prefix_purchase_number: '',
        title: '',
        sidebar_bg_color: defaultSidebarColor,
    });

    const [errors, setErrors] = useState({});
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (initialData) {
            setFormData({
                prefix_purchase_number: initialData.prefix_purchase_number || '',
                title: initialData.title || '',
                sidebar_bg_color: initialData.sidebar_bg_color || defaultSidebarColor,
            });
        }
    }, [initialData]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));

        setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setIsSaving(true);
            await onSave(formData);
            setErrors({});
        } catch (error) {
            if (error.errors) {
                const newErrors = {};
                Object.keys(error.errors).forEach(key => {
                    newErrors[key] = Array.isArray(error.errors[key])
                        ? error.errors[key][0]
                        : error.errors[key];
                });
                setErrors(newErrors);
            } else {
                setErrors({
                    prefix_purchase_number: error.message || 'An error occurred while saving',
                });
            }
            return;
        } finally {
            setIsSaving(false);
        }
    };

    const isSubmitting = isLoading || isSaving;

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit} className="h-100 d-flex flex-column">
            <div className="d-flex justify-content-between mb-2">
                <div className="d-flex justify-content-start">
                    <h5 className="mb-0">Site Settings</h5>
                </div>
            </div>
            <div className="flex-grow-1">
                <div className="row">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-12">
                                <CommonInput
                                    name="title"
                                    label="Site Title"
                                    value={formData.title}
                                    onChange={handleChange}
                                    errors={errors}
                                    required={false}
                                    disabled={isSubmitting}
                                />
                            </div>
                            <div className="col-md-12">
                                <label htmlFor="sidebar_bg_color" className="form-label">
                                    Sidebar Background Color
                                </label>
                                <div className="d-flex align-items-center gap-2">
                                    <input
                                        type="color"
                                        id="sidebar_bg_color"
                                        name="sidebar_bg_color"
                                        value={formData.sidebar_bg_color}
                                        onChange={handleChange}
                                        disabled={isSubmitting}
                                        className="form-control form-control-color"
                                        style={{ width: '3rem', height: '2.5rem' }}
                                    />
                                    <span className="text-muted">{formData.sidebar_bg_color}</span>
                                </div>
                                {errors.sidebar_bg_color && (
                                    <div className="invalid-feedback d-block">{errors.sidebar_bg_color}</div>
                                )}
                            </div>
                            <div className="col-md-12 d-none">
                                <CommonInput
                                    name="prefix_purchase_number"
                                    label="Purchase Invoice prefix"
                                    value={formData.prefix_purchase_number}
                                    onChange={handleChange}
                                    errors={errors}
                                    required={false}
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="form-footer">
                <button
                    type="button"
                    className="btn btn-light"
                    onClick={onClose}
                    disabled={isSubmitting}
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isSubmitting}
                >
                    {isSaving ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" />
                            Saving...
                        </>
                    ) : 'Save'}
                </button>
            </div>
        </form>
    );
};

export default GeneralSettingsForm;
